import { Badge, BadgeProps, Text } from '@cmpsr/components';

type AboveAverageBadgeProps = BadgeProps & {
  isRisk?: boolean;
};

export default function AboveAverageBadge({ isRisk, ...props }: AboveAverageBadgeProps) {
  const text = isRisk ? 'Above Average Risk' : 'Above Average';

  return (
    <Badge w="max-content" backgroundColor="alert-error-default" py="2px" {...props}>
      <Text color="text-error" variant="text-body-floating-label-bold" textTransform="capitalize">
        {text}
      </Text>
    </Badge>
  );
}
